<template>
  <div>
    <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
      <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>客户信息</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="客户名称" prop="name">
              <el-input v-model="form.model.name" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="公司登记名称" prop="registerName">
              <el-input v-model="form.model.registerName" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="服务等级" prop="serviceLevel">
              <dictionary-select v-model="form.model.serviceLevel" :disabled="!editable" :factory-name="'domain'" :params="'SERVICELEVEL'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="所属数据中心" prop="roomIds">
              <dictionary-select v-model="form.model.roomIds" :disabled="!editable" :factory-name="'room'" :params="{type: 'ALL'}"
                                 clearable filterable multiple size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="客户来源" prop="customerFrom">
              <dictionary-select v-model="form.model.customerFrom" :disabled="!editable" :factory-name="'domain'" :params="'CUSTOMERFROM'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="客户类型" prop="customerType">
              <dictionary-select v-model="form.model.customerType" :disabled="!editable" :factory-name="'domain'" :params="'CUSTOMERTYPE'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="经营许可证编号" prop="licenceNo">
              <el-input v-model="form.model.licenceNo" :disabled="!editable" maxlength="60" placeholder="限60字符" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="单位所属行业" prop="industry">
              <dictionary-select v-model="form.model.industry" :disabled="!editable" :factory-name="'domain'" :params="'INDUSTRY'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="单位所在省" prop="province">
              <region-select v-model="form.model.province" :parent-region="{code: '86'}" @change="handleProvinceChange" :disabled="!editable" clearable filterable size="small"></region-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="单位所在市" prop="city">
              <region-select v-model="form.model.city" :parent-region="provinceRegion" @change="handleCityChange" :disabled="!editable" clearable filterable size="small"></region-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="单位所在县区" prop="district">
              <region-select v-model="form.model.district" :parent-region="cityRegion" :disabled="!editable" clearable filterable size="small"></region-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="邮编" prop="postcode">
              <el-input v-model="form.model.postcode" :maxlength="8" :disabled="!editable" placeholder="限8字符" size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="24">
            <el-form-item label="客户详细地址" prop="address">
              <el-input v-model="form.model.address" :maxlength="250" placeholder="限250字符" :disabled="!editable" size="small" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-form-item label="授权人员" prop="userIdsArray">
              <person-select v-model="form.model.userIdsArray" :athub-value-key="'personuid'" :disabled="true"
                             :filterable="true" :clearable="true" :multiple="true" size="small" v-if="!editable">
              </person-select>
              <person-select v-model="form.model.userIdsArray" :eq-status="'1'" :athub-value-key="'personuid'"
                             :filterable="true" :clearable="true" :multiple="true" size="small" v-if="editable">
              </person-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-form-item label="备注" prop="comment">
              <el-input v-model="form.model.comment" :maxlength="250" placeholder="限250字符" :disabled="!editable" size="small" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <!--<el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>付费配置</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="收款单位" prop="bcop">
              <el-input v-model="form.model.bcop" :maxlength="100" placeholder="限100字符" :disabled="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="开户银行" prop="bbank">
              <el-input v-model="form.model.bbank" :maxlength="100" placeholder="限100字符" :disabled="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="账号" prop="bacc">
              <el-input v-model="form.model.bacc" :maxlength="30" placeholder="限30字符" :disabled="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="联系人" prop="bcon">
              <el-input v-model="form.model.bcon" :maxlength="30" placeholder="限30字符" :disabled="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="电话" prop="bphone">
              <el-input v-model="form.model.bphone" :maxlength="30" placeholder="限30字符" :disabled="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>-->
    </el-form>

  </div>
</template>

<script>
  import _ from 'lodash'
  import Emitter from 'element-ui/src/mixins/emitter'

  import DictionarySelect from "@/components/common/DictionarySelect"
  import RegionSelect from "@/components/common/region/region.select"
  import PersonSelect from '@/views/workorder/components/person/person-select'
  import {AuthInfo} from '@/util/user/authInfo'

  import {
    COMPONENT_MAIN, COMPONENT_DETAIL,
    TAB_LIST,
    FN_LIST_QUERY, OPERATION_DETAIL_SHOW, OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT,
    FN_SET_TAB, FN_SET_OPERATION,
    ENUM_WORK_TIME_NAME_NORMAL, ENUM_WORK_TIME_NAME_DAY, ENUM_WORK_TIME_NAME_NIGHT,
    ENUM_WORK_TIME_TYPE_NORMAL, ENUM_WORK_TIME_TYPE_TURN
  } from "./customer.common";
  import BillingServer from '@/api/billing'
  import {handleError} from "@/util/error-util";

  export default {
    name: COMPONENT_DETAIL,
    componentName: COMPONENT_DETAIL,
    mixins: [Emitter],
    components: {
      DictionarySelect,
      RegionSelect,
      PersonSelect,
    },
    props: {
      operation: {
        type: String,
        default: OPERATION_DETAIL_SHOW
      },
      id: {
      },
    },
    data() {
      return {
        provinceRegion: null,
        cityRegion: null,
        form: {
          old: {},
          model: {
            id: null,
            name: null,
            registerName: null,
            serviceLevel: null,
            roomIds: null,
            customerFrom: null,
            industry: null,
            licenceNo: null,
            customerType: null,
            province: null,
            city: null,
            district: null,
            postcode: null,
            address: null,
            userIdsArray: [],
            comment: null,

            bcop: null,
            bbank: null,
            bacc: null,
            bcon: null,
            bphone: null,

            status: null,
            userIds: null,
          },
        },
      }
    },
    computed: {
      formRules() {
        return {
          name: [
            { required: true, message: '请填写客户名称', trigger: 'blur' },
          ],
          registerName: [
            { required: true, message: '请填写公司等级名称', trigger: 'blur' },
          ],
          serviceLevel: [
            { required: true, message: '请选择服务等级', trigger: 'change' },
          ],
          roomIds: [
            { required: true, message: '请选择所属数据中心', trigger: 'change' }
          ],
          customerFrom: [
            { required: true, message: '请选择客户来源', trigger: 'change' },
          ],
          customerType: [
            { required: true, message: '请选择客户来源', trigger: 'change' }
          ],
          industry: [
            { required: true, message: '请选择单位所属行业', trigger: 'change' }
          ],
          address: [
            { required: true, message: '请填写客户详细地址', trigger: 'blur' }
          ],
          userIdsArray: [
            { required: true, message: '请选择授权人员', trigger: 'change' }
          ],
          /*bcop: [
            { required: true, message: '请填写收款单位', trigger: 'blur' }
          ],
          bbank: [
            { required: true, message: '请填写开户银行', trigger: 'blur' }
          ],
          bacc: [
            { required: true, message: '请填写账号', trigger: 'blur' }
          ],
          bcon: [
            { required: true, message: '请填写联系人', trigger: 'blur' }
          ],
          bphone: [
            { required: true, message: '请填写电话', trigger: 'blur' }
          ],*/
        };
      },
      editable() {
        return (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT && this.form.model.id != null);
      },
    },
    watch: {
      id: {
        handler(value) {
          if (value != null) {
            this.loadFormModel(value);
            this.$refs['form'].resetFields();
          }
        }
      },
      'form.model.name': {
        immediate: true,
        handler(value) {
          if (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT) {
            if (value === ENUM_WORK_TIME_NAME_NORMAL) {
              this.form.model.type = ENUM_WORK_TIME_TYPE_NORMAL;
            } else if (value == ENUM_WORK_TIME_NAME_DAY || value == ENUM_WORK_TIME_NAME_NIGHT) {
              this.form.model.type = ENUM_WORK_TIME_TYPE_TURN;
            }
          }
        }
      },
      'form.model.type': {
        immediate: true,
        handler(value) {
          if (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT) {
            if (value === ENUM_WORK_TIME_TYPE_NORMAL) {
              this.form.model.name = ENUM_WORK_TIME_NAME_NORMAL;
              this.form.model.period = 7;
            } else if (value == ENUM_WORK_TIME_TYPE_TURN) {
              if (this.form.model.name === ENUM_WORK_TIME_NAME_NORMAL) {
                this.form.model.name = null;
              }
              this.form.model.period = 4;
            }
          }
        }
      },
      'form.model.province': {
        immediate: true,
        handler(value) {
          if (value != null && value !== '') {
            this.provinceRegion = {name: value};
          } else {
            this.provinceRegion = null;
          }
        }
      },
      'form.model.city': {
        immediate: true,
        handler(value) {
          if (value != null && value !== '') {
            this.cityRegion = {name: value};
          } else {
            this.cityRegion = null;
          }
        }
      },
    },
    methods: {
      handleProvinceChange(event) {
        this.provinceRegion = event[1];
        this.form.model.city = null;
        this.form.model.district = null;
      },
      handleCityChange(event) {
        this.cityRegion = event[1];
        this.form.model.district = null;
      },
      loadFormModel(id) {
        BillingServer.customer.get(id).then((res) => {
          if (String(res.data.code) === '200' || res.data.success) {
            let model = this._toModel(res.data.data);
            this.form.old = _.merge({}, model);
            this.form.model = model;
          } else {
            this.$message.error(res.data.message);
          }
        }, (error) => {
          handleError(error);
        });
      },
      toAdd() {
        /*this.dispatch(COMPONENT_MAIN, FN_SET_TAB, TAB_DETAIL);
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_ADD);*/
        this.form.model = {
          id: null,
          name: null,
          registerName: null,
          serviceLevel: null,
          roomIds: null,
          customerFrom: null,
          industry: null,
          licenceNo: null,
          customerType: null,
          province: null,
          city: null,
          district: null,
          postcode: null,
          address: null,
          userIdsArray: [parseInt(AuthInfo.userId)],
          comment: null,

          bcop: null,
          bbank: null,
          bacc: null,
          bcon: null,
          bphone: null,

          status: 1,
          userIds: null,
        };
        this.$refs['form'].resetFields();
      },
      saveAdd() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            BillingServer.customer.add(
                data, {loading: true}
            ).then((res) => {
              if (String(res.data.code) === '200' || res.data.success) {
                this.$message.success('保存成功');

                let model = this._toModel(res.data.data);
                this.form.model = model;

                this.loadFormModel(model.id);
                this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
              } else {
                this.$message.error(res.data.message);
              }
            }, (error) => {
              handleError(error);
            });
          } else {
            return false;
          }
        });
      },
      saveEdit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let old = this.form.old;
            let data = this._toData(this.form.model);
            BillingServer.customer.update(
                data['id'], data, {loading: true}
            ).then((res) => {
              if (String(res.data.code) === '200' || res.data.success) {
                this.$message.success('保存成功');

                let model = this._toModel(res.data.data);
                this.form.model = model;

                this.loadFormModel(model.id);
                this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);

              } else {
                this.$message.error(res.data.message);
              }
            }, (error) => {
              handleError(error);
            });
          } else {
            return false;
          }
        });
      },
      cancelEdit() {
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
        this.$refs['form'].resetFields();
        this.loadFormModel(this.id);
      },
      reset() {
        let id = this.id;
        this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_DETAIL_SHOW);
        this.$refs['form'].resetFields();
        if (id != null) {
          this.loadFormModel(this.id);
        }
      },
      toRemove() {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BillingServer.customer.delete(this.form.model['id'], {loading: true}).then((res) => {
            if (res.data.code === 200 || res.data.success) {
              this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, FN_LIST_QUERY);
              this.dispatch(COMPONENT_MAIN, FN_SET_TAB, TAB_LIST);
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.message}`);
            }
          });
        }, () => {})
      },
      _toModel(data) {
        let model = JSON.parse(JSON.stringify(data));
        let dataRoomIds = model.roomIds;
        let modelRoomIds = [];
        if (dataRoomIds != null && String(dataRoomIds).trim() !== '') {
          let roomIdStrs = dataRoomIds.split(',');
          modelRoomIds = roomIdStrs.filter(roomIdStr => roomIdStr.trim() !== '').map(roomIdStr => parseInt(roomIdStr.trim()));
        }
        model._roomIds = model.roomIds;
        model.roomIds = modelRoomIds;
        let userIdsArray = [];
        if (model.userIds != null) {
          userIdsArray = _.uniq(model.userIds.split(',').map(userId => parseInt(userId)));
        }
        model.userIdsArray = userIdsArray;
        return model;
      },
      _toData(model) {
        let data = JSON.parse(JSON.stringify(model));
        let modelRoomIds = data.roomIds;
        data.roomIds = modelRoomIds == null ? "" : modelRoomIds.join(',');
        data.userIds = data.userIdsArray == null ? null : data.userIdsArray.join(',');
        return data;
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>
